export const actionsAfterDelay = action => {
  document.body.classList.add("dialog-close");
  setTimeout(() => {
    document.body.classList.remove("dialog-close");
    action();
  }, 700);
};
